import { connect } from "react-redux";
import CreditCardFieldset from "app/pages/Booking/Payment/CreditCardFieldset/CreditCardFieldset";
import { bindActionCreators } from "redux";
import { updateEncryptedCard } from "app/pages/Booking/Payment/paymentActionCreators";

const mapStateToProps = state => {
	const selectedPaymentType = state.booking.paymentType;
	const selectedPaymentMode = state.booking.paymentMode;
	const paymentTypes = state.payment.paymentTypes;

	const selectedPaymentTypeData = paymentTypes.find(paymentType => {
		return (
			paymentType.paymentType === selectedPaymentType &&
			paymentType.terms === selectedPaymentMode
		);
	});

	return {
		acceptedCreditCardTypes: selectedPaymentTypeData?.acceptedCreditCardTypes,
		adyenFlowPaymentSession: selectedPaymentTypeData?.paymentSession,
	};
};

const mapDispatchToProps = dispatch => {
	return bindActionCreators({ updateEncryptedCard }, dispatch);
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(CreditCardFieldset);
